'use client';
// Ressources & évaluation (G3) — POINT D'ENTRÉE UNIQUEMENT.
//
// Ce fichier portait à lui seul 1 262 lignes : équipements et métrologie, CQI
// (Levey-Jennings, règles de Westgard), EEQ, organigramme, transfert de
// responsabilités, habilitations, cartographie des processus et vue auditeur.
// Sept écrans sans rapport les uns avec les autres, réunis par leur seule
// appartenance au lot « G3 ».
//
// Le 2026-07-28, deux chantiers menés en parallèle sur ce fichier (paramétrage
// des règles CQI d'un côté, validation des passages de l'autre) se sont
// marchés dessus : l'écran a cassé sur des symboles absents, et le défaut n'a
// été visible qu'à l'exécution. Un fichier qui rassemble sept sujets rend ce
// genre de collision quasi inévitable.
//
// Chaque écran vit désormais dans son propre fichier (`./ressources/`), et les
// primitives communes dans `./ressources/commun`. Ce module ne fait plus que
// réexporter : les imports existants (`@/components/screens/Ressources`)
// continuent de fonctionner à l'identique.
export { Equipements } from './ressources/Equipements';
export { Maintenances } from './ressources/Maintenances';
export { Cqi } from './ressources/Cqi';
export { CqiSaisie } from './ressources/CqiSaisie';
export { QualiteAnalytique } from './ressources/QualiteAnalytique';
export { CqeEnvois } from './ressources/CqeEnvois';
export { Eeq } from './ressources/Eeq';
export { Organigramme } from './ressources/Organigramme';
export { Habilitations } from './ressources/Habilitations';
export { Processus } from './ressources/Processus';
export { VueAuditeur } from './ressources/VueAuditeur';
